export const environment = {
  production: true,
  api_url: "https://archive.1947partitionarchive.org"
};